import React, { useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import { useNavigate } from "react-router-dom";
import TextFormEditor from "./../../../component/atoms/input/textFormEditor";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import BoardApi from "../../../api/board.api";
import scrollToTop from "../../../util/scrollToTop";
import { route } from "../../../router/route";

const FirstVisitCreate = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [content, setContent] = useState();

  // ---------- 라이팅크루지도 생성 ---------- //
  const createGuide = async () => {
    try {
      const data = {
        boardCategoryId: 1,
        title: "라이팅크루가 처음이라면?",
        content: content,
        boardPostType: "FIRST_TIME",
      };
      await BoardApi.createBoard(data);

      navigate(route.community_first, { replace: true });
      scrollToTop();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>라이팅크루가 처음이라면?</TableTitle>
          <TextFormEditor
            placeholder={"상세 내용을 입력해주세요"}
            value={content}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onChange={(e) => {
              setContent(e);
            }}
            editorHeight={600}
            style={{
              width: "100%",
            }}
          />
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            {/* <BasicBtn isBlue={true} onClick={() => {}}>
              미리보기
            </BasicBtn> */}
            <BasicBtn
              onClick={() => {
                createGuide();
              }}
            >
              업로드하기
            </BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default FirstVisitCreate;
